'use client';
import cn from 'clsx';
import MenuOpts from './menuOpts';
import styles from '../reviews.module.scss';
import HelpfulButton from './HelpfulButton';
import { useState, useEffect } from 'react';
import { useTranslation } from '@/i18n/client';
import {
  ReviewTipType,
  ReviewedRes,
  anonymousData,
} from '@/app/csr-src/apis/profile/review.interface';
import {
  sendClickTrack as myReviewSendClickTrack,
  EXPOSURE_RECORD as MY_REVIEW_EXPOSURE_RECORD,
} from '@/tracks/25155';
import { useStores } from '@/models';
import PingLunIcon from '@/assets/icons/lun.svg';
interface Props {
  pageType?: string;
  commentItem: ReviewedRes;
  onComment?: () => void;
  onRefresh?: () => void;
  onAnonymousChange?: (data: anonymousData) => void;
}

export default function CommentBottomOpts({
  pageType,
  commentItem,
  onComment,
  onRefresh,
  onAnonymousChange,
}: Props) {
  const {
    skuId,
    commentId,
    anonymousFlag,
    parentReplyId,
    commentNum: outerCommentNum,
  } = commentItem || {};

  const { t } = useTranslation();
  const { commentOpstsStore } = useStores();
  const [commentNum, setCommentNum] = useState(outerCommentNum);
  const [isAnoymous, setIsAnonymouse] = useState<boolean>(anonymousFlag);
  const [expConfig, setExpConfig] = useState<any>(null);

  const onAnonymous = (is: boolean, data: anonymousData) => {
    setIsAnonymouse(is);
    onAnonymousChange?.(data);
  };

  const onCommentChange = (newCommentId: string, newValue: number) => {
    if (newCommentId === commentId) {
      setCommentNum(newValue);
    }
  };

  commentOpstsStore.onCommentChange(onCommentChange);

  useEffect(() => {
    const config = '{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}';
    switch (pageType) {
      case 'reviewComment':
        setExpConfig({
          help: {
            expTag: 'exp|' + MY_REVIEW_EXPOSURE_RECORD.My_Reviews_Completed_Btn_Expo,
            data: { button_name: '1', commentId: `${commentId}` },
            config: config,
          },
          comment: {
            expTag: 'exp|' + MY_REVIEW_EXPOSURE_RECORD.My_Reviews_Completed_Btn_Expo,
            data: { button_name: '2', commentId: `${commentId}` },
            config: config,
          },
          more: {
            expTag: 'exp|' + MY_REVIEW_EXPOSURE_RECORD.My_Reviews_Completed_Btn_Expo,
            data: { button_name: '3', commentId: `${commentId}` },
            config: config,
          },
          delete: {
            expTag: 'exp|' + MY_REVIEW_EXPOSURE_RECORD.My_Reviews_More_Layer_Expo,
            data: { button_name: '2', commentId: `${commentId}` },
            config: config,
          },
        });
        break;

      default:
        break;
    }
  }, [pageType, commentId]);

  return (
    <div className={styles.basicButton} onClick={(e) => e?.stopPropagation()}>
      {/* {isAnoymous && <span className={styles.anonymous}>Anonymous</span>} */}
      {expConfig && (
        <>
          {commentItem?.tipType !== ReviewTipType.Report && (
            <>
              <HelpfulButton data={commentItem} pageType={pageType} expConfig={expConfig} />
              <div className={styles.line}></div>
              <div
                className={styles.btn}
                exptag={expConfig?.comment?.expTag}
                data-exptag-json-param={JSON.stringify(expConfig?.comment?.data)}
                data-exptag-config={expConfig?.comment?.config}
                onClick={() => {
                  /** 点击事件上报-已完成评价tab下按钮点击 */
                  switch (pageType) {
                    case 'reviewComment':
                      // {"button_name":"1-helpful，2-comment，3-more","commentId":""}
                      myReviewSendClickTrack.My_Reviews_Completed_Btn({
                        button_name: '2',
                        commentId: commentId,
                      });
                      break;

                    default:
                      break;
                  }
                  onComment?.();
                }}
              >
                {/* <i className={cn(styles.pinglunIcon, styles.mar)}></i> */}
                <PingLunIcon className={cn(styles.pinglunIcon, styles.mar)}></PingLunIcon>
                {`${t('dp.commentSection.comment')}${commentNum ? '(' + commentNum + ')' : ''}`}
              </div>
              <div className={styles.line}></div>
            </>
          )}

          <MenuOpts
            pageType={pageType}
            anonymous={isAnoymous}
            expConfig={expConfig}
            params={{ skuId, commentId }}
            onRefresh={onRefresh}
            onAnonymous={onAnonymous}
          />
        </>
      )}
    </div>
  );
}
